import PartnerLayout from 'components/partner/partner_layout';
import { FrontendErrorFallback } from 'components/shared/frontend_error_fallback';
import AuthorityStateContainer from 'containers/authority_state_container';
import DealerUserAuth from 'containers/dealer_user_auth';
import PartnerInstrumentSharingRoute from 'containers/partner_instrument_sharing_route';
import PartnerStateContainer from 'containers/partner_state_container';
import BarcodeIndex from 'pages/partner/barcode/index';
import BarcodePreview from 'pages/partner/barcode/preview';
import DefectReportIndex from 'pages/partner/defect_report';
import DefectReportShow from 'pages/partner/defect_report/show';
import { ExColumnIndex } from 'pages/partner/ex_column';
import InquiryIndex from 'pages/partner/inquiry';
import InstrumentIndex from 'pages/partner/instrument';
import InstrumentImport from 'pages/partner/instrument/import';
import InstrumentShow from 'pages/partner/instrument/show';
import InstrumentRelationEventIndex from 'pages/partner/instrument_relation_event';
import Login from 'pages/partner/login/index';
import ProofreadPlanIndex from 'pages/partner/proofread_plan';
import ProofreadPlanShow from 'pages/partner/proofread_plan/show';
import ProofreadableInstrumentIndex from 'pages/partner/proofreadable_instrument/index';
import RepairEstimateIndex from 'pages/partner/repair_estimate';
import RepairEstimateShow from 'pages/partner/repair_estimate/show';
import RepairEventIndex from 'pages/partner/repair_event';
import RepairEventShow from 'pages/partner/repair_event/show';
import RepairInfoShow from 'pages/partner/repair_info/show';
import SettingShow from 'pages/partner/setting/show';
import UnmanagedInstrumentIndex from 'pages/partner/unmanaged_instrument/index';
import UnprintedBarcodeIndex from 'pages/partner/unprinted_barcode/index';
import React from 'react';
import { RouteObject } from 'react-router-dom';

export class PartnerRouteHelper {
  public static root = (): string => '/partner';
  static basePath = (path: string): string => `${PartnerRouteHelper.root()}/${path}`;

  // ログイン
  public static login = (): string => PartnerRouteHelper.basePath('login');

  // 機器
  public static instrumentIndex = (): string => PartnerRouteHelper.basePath('instruments');
  public static instrumentShow = (id: number | string): string => PartnerRouteHelper.basePath(`instruments/${id}`);
  public static instrumentRepairResultIndex = (instrumentId: number | string): string =>
    PartnerRouteHelper.basePath(`instruments/${instrumentId}/repair_results`);
  public static instrumentImport = (): string => PartnerRouteHelper.basePath('import/instruments');

  // QR・バーコード
  public static barcodeIndex = (): string => PartnerRouteHelper.basePath('barcodes');
  public static barcodePreview = (): string => PartnerRouteHelper.basePath('barcodes/preview');
  public static unprintedBarcodeIndex = (): string => PartnerRouteHelper.basePath('unprinted_barcodes');

  // 管理対象外の機器
  public static unmanagedInstrumentIndex = (): string => PartnerRouteHelper.basePath('unmanaged_instruments');

  // 不具合報告一覧
  public static defectReportIndex = (): string => PartnerRouteHelper.basePath('defect_reports');
  public static defectReportShow = (id: number | string): string => PartnerRouteHelper.basePath(`defect_reports/${id}`);

  // 校正管理
  public static proofreadPlanIndex = (): string => PartnerRouteHelper.basePath('proofread_plans');
  public static proofreadPlanShow = (id: number | string): string =>
    PartnerRouteHelper.basePath(`proofread_plans/${id}`);
  public static proofreadableInstrumentIndex = (): string => PartnerRouteHelper.basePath('proofreadable_instruments');

  // 修理管理
  public static repairInfoShow = (id: number | string): string => PartnerRouteHelper.basePath(`repair_infos/${id}`);

  // 修理結果
  public static repairEventIndex = (): string => PartnerRouteHelper.basePath('repair_events');
  public static repairEventShow = (id: number | string): string => PartnerRouteHelper.basePath(`repair_events/${id}`);

  // 修理見積
  public static repairEstimateIndex = (): string => PartnerRouteHelper.basePath('repair_estimates');
  public static repairEstimateShow = (id: number | string): string =>
    PartnerRouteHelper.basePath(`repair_estimates/${id}`);

  // 機器共有イベント
  public static instrumentRelationEventIndex = (): string => PartnerRouteHelper.basePath('instrument_relation_events');

  // 管理情報
  public static exAttributeIndex = (): string => PartnerRouteHelper.basePath('ex_attributes');

  // 問合せ
  public static inquiryIndex = (): string => PartnerRouteHelper.basePath('inquiries');
  public static inquiryShow = (id: number | string): string => PartnerRouteHelper.basePath(`inquiries/${id}`);

  // 設定
  public static settingShow = (): string => PartnerRouteHelper.basePath('setting');
}

export const partnerRoutes: RouteObject[] = [
  {
    element: <PartnerStateContainer />,
    errorElement: <FrontendErrorFallback />,
    children: [
      { path: PartnerRouteHelper.root(), element: <Login /> },
      { path: PartnerRouteHelper.login(), element: <Login /> },
      {
        element: <DealerUserAuth />,
        children: [
          {
            element: <AuthorityStateContainer />,
            children: [
              {
                element: <PartnerLayout />,
                children: [
                  {
                    // 機器一覧
                    path: PartnerRouteHelper.instrumentIndex(),
                    element: <InstrumentIndex />,
                  },
                  {
                    // 機器詳細
                    path: PartnerRouteHelper.instrumentShow(':id'),
                    element: <InstrumentShow />,
                  },
                  {
                    // 機器インポート
                    path: PartnerRouteHelper.instrumentImport(),
                    element: <InstrumentImport />,
                  },
                  {
                    // バーコード一覧
                    path: PartnerRouteHelper.barcodeIndex(),
                    element: <BarcodeIndex />,
                  },
                  {
                    // バーコードプレビュー
                    path: PartnerRouteHelper.barcodePreview(),
                    element: <BarcodePreview />,
                  },
                  {
                    // 未印刷バーコード一覧
                    path: PartnerRouteHelper.unprintedBarcodeIndex(),
                    element: <UnprintedBarcodeIndex />,
                  },
                  {
                    // 管理対象外の機器
                    path: PartnerRouteHelper.unmanagedInstrumentIndex(),
                    element: <UnmanagedInstrumentIndex />,
                  },
                  {
                    // 不具合報告一覧
                    path: PartnerRouteHelper.defectReportIndex(),
                    element: <DefectReportIndex />,
                  },
                  {
                    // 不具合報告詳細
                    path: PartnerRouteHelper.defectReportShow(':id'),
                    element: <DefectReportShow />,
                  },
                  {
                    // 修理情報
                    path: PartnerRouteHelper.repairInfoShow(':id'),
                    element: <RepairInfoShow />,
                  },
                  {
                    // 修理結果一覧
                    path: PartnerRouteHelper.repairEventIndex(),
                    element: <RepairEventIndex />,
                  },
                  {
                    // 修理結果詳細
                    path: PartnerRouteHelper.repairEventShow(':id'),
                    element: <RepairEventShow />,
                  },
                  {
                    // 修理見積一覧
                    path: PartnerRouteHelper.repairEstimateIndex(),
                    element: <RepairEstimateIndex />,
                  },
                  {
                    // 修理見積詳細
                    path: PartnerRouteHelper.repairEstimateShow(':id'),
                    element: <RepairEstimateShow />,
                  },
                  {
                    // 校正計画一覧
                    path: PartnerRouteHelper.proofreadPlanIndex(),
                    element: <ProofreadPlanIndex />,
                  },
                  {
                    // 校正計画詳細
                    path: PartnerRouteHelper.proofreadPlanShow(':id'),
                    element: <ProofreadPlanShow />,
                  },
                  {
                    // 校正対象機器一覧
                    path: PartnerRouteHelper.proofreadableInstrumentIndex(),
                    element: <ProofreadableInstrumentIndex />,
                  },
                  {
                    // 管理情報
                    path: PartnerRouteHelper.exAttributeIndex(),
                    element: <ExColumnIndex />,
                  },
                  {
                    // 問合せ
                    path: PartnerRouteHelper.inquiryShow(':id'),
                    element: <InquiryIndex />,
                  },
                  {
                    // 設定画面
                    path: PartnerRouteHelper.settingShow(),
                    element: <SettingShow />,
                  },
                  {
                    element: <PartnerInstrumentSharingRoute />,
                    // 機器共有が有効な場合のみ以下のルートを追加
                    children: [
                      {
                        // 機器共有
                        path: PartnerRouteHelper.instrumentRelationEventIndex(),
                        element: <InstrumentRelationEventIndex />,
                      },
                      {
                        // 問合せ一覧
                        path: PartnerRouteHelper.inquiryIndex(),
                        element: <InquiryIndex />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
